<script lang="ts" setup>
import IIconTop from '~/assets/images/events/icon-indicator.svg?component'

const emit = defineEmits<{
  (event: 'closeModal'): void
}>()

const modelValue = defineModel<boolean>()

function closeModal() {
  modelValue.value = false
  emit('closeModal')
}
</script>

<template>
  <HeadlessTransitionRoot appear :show="modelValue" as="template">
    <HeadlessDialog as="div" @close="closeModal" class="relative z-10">
      <HeadlessTransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 backdrop-modal" />
      </HeadlessTransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div class="flex min-h-full items-end justify-center text-center">
          <HeadlessTransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 translate-y-1/3 scale-95"
            enter-to="opacity-100 translate-y-0 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 translate-y-0 scale-100"
            leave-to="opacity-0 translate-y-1/3 scale-95"
          >
            <HeadlessDialogPanel
              class="w-full max-w-md transform overflow-hidden rounded-t-[1.875rem] bg-[#151515] p-6 text-left align-middle transition-all origin-bottom"
            >
              <slot />
            </HeadlessDialogPanel>
          </HeadlessTransitionChild>
        </div>
      </div>
    </HeadlessDialog>
  </HeadlessTransitionRoot>

  <!-- <div v-if="modelValue">
        <div
          class="
            fixed
            top-0
            bottom-0
            left-0
            right-0
            h-full
            w-full
            z-99998
            bg-[rgba(255,255,255,0.70)]
          "
          style="
            background: rgba(0, 0, 0, 0.7);

            box-shadow: 0px 24px 40px -11px rgba(0, 0, 0, 0.1),
              0px -13px 24px -7px rgba(0, 0, 0, 0.05);
            backdrop-filter: blur(7.5px);
          "
          @click="closeModal()"
        />

        <div
          class="
            fixed
            bottom-0
            left-0
            right-0
            bg-[#151515]
            z-99999
            rounded-t-[1.875rem]
            pb-5
            sm:w-150 sm:mx-auto
          "
        >
         <IIconTop class="mx-auto mt-1.5" />
          <div class="w-full flex flex-col">
            <slot />
          </div>
        </div>
      </div> -->
</template>

<style>
.backdrop-modal {
  background: rgba(0, 0, 0, 0.7);

  box-shadow:
    0px 24px 40px -11px rgba(0, 0, 0, 0.1),
    0px -13px 24px -7px rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(7.5px);
}
</style>
